
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToReservation = () => {
    const element = document.getElementById('reservation');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="accueil" 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/d844ea98ada8b216c121eafdea8cae50.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-6 py-20 text-center text-white">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            <strong>Détente Absolue</strong> en <strong>Guadeloupe</strong>
          </h1>
          <p className="text-xl md:text-2xl mb-8 leading-relaxed opacity-90">
            Découvrez nos <strong>massages thérapeutiques</strong> et soins de <strong>bien-être</strong> 
            dans le cadre paradisiaque de la <strong>Guadeloupe</strong>. 
            Thérapeutes certifiés, techniques ancestrales et moderne.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Button 
              size="lg" 
              onClick={scrollToReservation}
              className="text-lg px-10 py-4"
            >
              <i className="ri-calendar-line mr-2"></i>
              Réserver Maintenant
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              className="text-lg px-10 py-4 bg-white/10 backdrop-blur-sm border-white text-white hover:bg-white hover:text-gray-900"
            >
              <i className="ri-eye-line mr-2"></i>
              Découvrir nos Services
            </Button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center">
              <div className="w-16 h-16 bg-purple-400 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-award-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Thérapeutes Certifiés</h3>
              <p className="opacity-90">Plus de 10 ans d'expérience en massothérapie</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center">
              <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-home-heart-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Service à Domicile</h3>
              <p className="opacity-90">Massages dans le confort de votre domicile</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 text-center">
              <div className="w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-leaf-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold mb-2">Produits Naturels</h3>
              <p className="opacity-90">Huiles essentielles et produits bio locaux</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
